import React from 'react';
import BannerMidia from '../../../components/Campanhas/BannerMidia';

const Midia = () => (
	<>
		<BannerMidia />
	</>
);

export default Midia;
